import i18next from './i18n';
import { tenantSpecificResources } from './resources';

/**
 * Carga las traducciones específicas del tenant
 * @param {string} tenantName - Nombre del tenant
 * @param {string} language - Idioma actual
 */
export function loadTenantSpecificTranslations(tenantName, language) {
  if (!tenantName || !tenantSpecificResources[tenantName]) {
    return;
  }

  const tenantResources = tenantSpecificResources[tenantName];

  if (tenantResources[language]) {
    tenantResources[language].forEach((resource) => {
      Object.keys(resource).forEach((namespace) => {
        i18next.addResources(language, namespace, resource[namespace]);
      });
    });
  }
}

/**
 * Obtiene el nombre del tenant desde el store
 * @param {Object} store - Redux store
 * @returns {string|null} - Nombre del tenant o null si no existe
 */
export function getTenantName(store) {
  const state = store.getState();
  const organization = state['system-setting']?.organization;
  return organization?.tenant?.name || null;
}

/**
 * Inicializa las traducciones del tenant si es necesario
 * @param {Object} store - Redux store
 * @param {string} language - Idioma actual
 */
export function initializeTenantTranslations(store, language) {
  const tenantName = getTenantName(store);
  if (tenantName) {
    loadTenantSpecificTranslations(tenantName, language);
  }
}
